<template>
  <el-container id="login">
    <el-header height="100px">
      Noosphere自动驾驶平台
    </el-header>
    <el-main>
      <el-form ref="ruleForm" :model="form" :rules="rules" label-position="top">
        <el-form-item label="登录名" prop="account">
          <el-input
            v-model="form.account"
            placeholder="请输入登录名"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="secret">
          <el-input
            v-model="form.secret"
            show-password
            placeholder="请输入登录密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verificationCode">
          <el-row>
            <el-col :span="16">
              <el-input
                v-model="form.verificationCode"
                placeholder="请输入验证码"
                :maxlength="4"
              ></el-input>
            </el-col>
            <el-col :span="6" :offset="2">
              <gVerify @emitAuthCode="upDateAuthCode" />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        :loading="loading"
        @click="handlerSubmit('ruleForm')"
        >登录</el-button
      >
    </el-main>
    <el-footer height="100px">
      版权所有：创客天下（北京）科技发展有限公司 ICP备</el-footer
    >
  </el-container>
</template>

<script>
import { storage } from "@/utils/public.js";
import GVerify from "./component/gVerify";
export default {
  name: "login",
  created() {
    storage.clearOneSession("token");
  },
  data() {
    return {
      loading: false,
      authCode: "",
      form: {
        account: "",
        secret: "",
        verificationCode: ""
      },
      rules: {
        account: [
          {
            required: true,
            message: "登录名不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (!/\w{5,20}/.test(value)) {
                return callback(new Error("登录名格式不正确"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        secret: [
          {
            required: true,
            message: "登录密码不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (!/\w{6,15}/.test(value)) {
                return callback(new Error("登录密码格式不正确"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        verificationCode: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (value.toLowerCase() === this.authCode.toLowerCase()) {
                callback();
              } else {
                callback(new Error("验证码输入有误"));
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    upDateAuthCode(data) {
      this.authCode = data;
    },
    handlerSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.loadCommit();
        }
      });
    },
    loadCommit() {
      this.requestApi("login", "commit", this.form, res => {
        this.loading = false;
        if (res.Code === 0) {
          storage.setSession("token", res.Token);
          this.setDate();
          this.redirectByPath("/admin");
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    setDate() {
      const d = new Date(),
        time = `${d.getFullYear()}年${d.getMonth() +
          1}月${d.getDate()}日 ${d.getHours()}时${d.getMinutes()}分`;
      storage.setSession("loginDate", time);
    }
  },
  components: {
    GVerify
  }
};
</script>

<style lang="less">
#login {
  .el-header,
  .el-footer {
    height: 10vh !important;
    line-height: 10vh;
    text-align: center;
  }
  .el-footer {
    margin-top: 10vh;
  }
  .el-main {
    box-sizing: border-box;
    width: 50vw;
    height: 50vh;
    padding: 2vh 5vw;
    margin: 10vh auto;
    border-radius: 10px;
    background: #fff;
    .el-button {
      width: 100%;
      margin-top: 22px;
    }
  }
}
</style>
